import { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatError } from "@/lib/api";

export default function EnquiryDialog({ course, onClose }) {
  const [form, setForm] = useState({ message: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (course) setForm({ message: `Hi, I'd like to know more about the ${course.title} — next batch dates, fees and eligibility.`, phone: "" });
  }, [course]);
  if (!course) return null;
  const { message } = form;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      await api.post("/enquiries", { course_id: course.id, message, phone: form.phone });
      toast.success("Enquiry sent! The IDDCR team will contact you soon.");
      onClose();
    } catch (e2) { setErr(formatError(e2)); }
    setBusy(false);
  };

  return (
    <Dialog open={!!course} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg bg-surface" data-testid="enquiry-dialog">
        <DialogHeader>
          <DialogTitle className="text-ink">Enquire about this course</DialogTitle>
          <DialogDescription>{course.title}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Label htmlFor="enq-msg">Your message</Label>
            <Textarea id="enq-msg" data-testid="enquiry-message-input" rows={5} maxLength={1000} value={message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="enq-phone">Phone / WhatsApp (optional)</Label>
            <Input id="enq-phone" data-testid="enquiry-phone-input" maxLength={20} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <p className="text-xs text-ink-3">Your name and account email are shared with the IDDCR admissions team.</p>
          {err && <p data-testid="enquiry-error" className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{err}</p>}
          <Button data-testid="enquiry-submit-btn" type="submit" disabled={busy || message.trim().length < 5} className="rounded-full">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="mr-2 h-4 w-4" />Send enquiry</>}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
